import { PORTFOLIO_ORIGIN } from '../../utils/navigationCacheUtils';

import { EXTERNAL_ROUTES } from '../../constants/urls';

import type { PortfolioOrigin } from '../../utils/navigationCacheUtils';

type Args = {
  listingAlias: string;
  isSelfServeOnboardingInProgress?: boolean;
  origin?: PortfolioOrigin;
};

// Detail routes live under /properties, so the page can't tell which list the user came from.
export const getListingBreadcrumb = ({ listingAlias, isSelfServeOnboardingInProgress, origin }: Args) => {
  if (isSelfServeOnboardingInProgress) {
    return { title: 'Listing Type Selection', url: `${EXTERNAL_ROUTES.SETUP_TASKS}/${listingAlias}/listingType` };
  }

  if (origin === PORTFOLIO_ORIGIN.listings) {
    return { title: 'Listings', url: EXTERNAL_ROUTES.LISTINGS };
  }

  return { title: 'Your properties', url: EXTERNAL_ROUTES.PROPERTIES };
};
